module.exports = __webpack_public_path__ + "img/slika-3.1c0774ee.png";